import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, Select } from 'antd';
import React, { Component } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { httpPost, httpUrl } from '../../api/httpClient';
import Const from '../../const';
import '../../css/modal.scss';
import { checkOverPrice, comma } from '../../lib/util/numberUtil';
import PriceInputModal from './PriceInputModal';
import CloseIcon from '../../img/body/close.png';
import {modalStyle} from "../../lib/util/codeUtil";

const FormItem = Form.Item;
const { Option } = Select;

class ChargeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMode: 0,
      phoneInputModalOpen: false,
      phoneInputModalTarget: '',
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
      let cardInfo = {
        cardNum1: '',
        cardNum2: '',
        cardNum3: '',
        cardNum4: '',
        cardExpire1: '',
        cardExpire2: '',
        amount: '',
      };
      if (this.props.autoPay) {
        //자동충전인경우 현재
        if (
          this.props.autoPayData.cardNum &&
          this.props.autoPayData.cardNum.length > 12
        ) {
          cardInfo.cardNum1 = this.props.autoPayData.cardNum.substr(0, 4);
          cardInfo.cardNum2 = this.props.autoPayData.cardNum.substr(4, 4);
          cardInfo.cardNum3 = this.props.autoPayData.cardNum.substr(8, 4);
          cardInfo.cardNum4 = this.props.autoPayData.cardNum.substr(
            12,
            this.props.autoPayData.cardNum.length - 12
          );
        }
        if (
          this.props.autoPayData.validThru &&
          this.props.autoPayData.validThru.length > 3
        ) {
          cardInfo.cardExpire1 = this.props.autoPayData.validThru.substr(2, 4);
          cardInfo.cardExpire2 = this.props.autoPayData.validThru.substr(0, 2);
        }
        if (this.props.autoPayData.amount) {
          cardInfo.amount = this.props.autoPayData.amount;
        }
      } else {
        //1회충전인경우 스토리지에서 불러온다
        const storageCardInfo = this.loadCardChargeInfo();
        cardInfo = Object.assign(cardInfo, storageCardInfo);
      }
      if (this.formRef.current) {
        this.formRef.current.setFieldsValue(cardInfo);
      }
    }
  }

  loadCardChargeInfo = () => {
    const cardCharge = reactLocalStorage.getObject(
      Const.appName + '#cardCharge'
    );
    if (!cardCharge) return;
    let cardChargeObj = {};
    try {
      cardChargeObj = JSON.parse(cardCharge);
      cardChargeObj.amount = '';
      return cardChargeObj;
    } catch (e) {
      return {};
    }
  };
  onUpdateOverPrice = () => {
    const overPrice = checkOverPrice(
      this.formRef.current.getFieldValue('cardExpire1'),
      this.state.overPrice,
      this.state.overPriceSetting
    );

    this.setState({ overPrice });
  };
  openPhoneInputModal = (target) => {
    this.setState({
      phoneInputModalTarget: target,
      phoneInputModalOpen: true,
    });
  };
  charge = () => {
    if (this.props.autoPay) {
      //자동충전설정
      const formData = this.formRef.current.getFieldsValue();
      const cardNum =
        formData.cardNum1 +
        formData.cardNum2 +
        formData.cardNum3 +
        formData.cardNum4;
      const validThru = formData.cardExpire2 + formData.cardExpire1;
      const amount = parseInt(formData.amount);

      if (amount < 50000) {
        Modal.info({
          title: '카드설정',
          content: <div>자동충전 금액은 50,000원 이상을 입력해야합니다.</div>,
          ...modalStyle,
          onOk() {},
        });
        return;
      }

      const self = this;
      httpPost(httpUrl.autoChargeUpdate, [], {
        cardNum,
        validThru,
        amount,
      })
        .then((result) => {
          result = result.data;
          if (result == 'SUCCESS') {
            Modal.info({
              title: '카드설정',
              content: <div>자동충전 카드가 등록되었습니다.</div>,
              ...modalStyle,
              onOk() {},
            });
            //캐시리로드
            self.props.close();
            this.props.getAutoCharge();
          } else {
            Modal.info({
              title: '카드설정실패',
              content: (
                <div>
                  카드설정에 실패하였습니다. 입력한 정보를 확인해주세요.
                </div>
              ),
              ...modalStyle,
              onOk() {},
            });
          }
        })
        .catch((e) => {
          Modal.info({
            title: '카드설정실패',
            content: (
              <div>카드설정에 실패하였습니다. 입력한 정보를 확인해주세요.</div>
            ),
            ...modalStyle,
            onOk() {},
          });
        });
    } else {
      //1회충전
      const formData = this.formRef.current.getFieldsValue();
      const cardNum =
        formData.cardNum1 +
        formData.cardNum2 +
        formData.cardNum3 +
        formData.cardNum4;
      const cardExpiry = formData.cardExpire2 + formData.cardExpire1;

      const self = this;
      Modal.confirm({
        ...modalStyle,
        content: comma(formData.amount) + '원을 카드로 충전하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        onOk() {
          httpPost(httpUrl.cardCharge, [], {
            cardNum,
            cardExpiry,
            amount: formData.amount,
          })
            .then((result) => {
              result = result.data;
              if (result) {
                Modal.info({
                  title: '예치금 충전',
                  content: <div>예치금이 성공적으로 충전되었습니다.</div>,
                  ...modalStyle,
                  onOk() {},
                });
                //캐시리로드
                self.props.renewDeposit();

                //폼리셋
                self.formRef.current.setFieldsValue({ amount: '' });

                //스토리지 저장
                reactLocalStorage.setObject(
                  Const.appName + '#cardCharge',
                  JSON.stringify(self.formRef.current.getFieldsValue())
                );
              } else {
                Modal.info({
                  title: '예치금 충전실패',
                  content: (
                    <div>
                      예치금이 충전에 실패하였습니다. 입력한 정보를
                      확인해주세요.
                    </div>
                  ),
                  ...modalStyle,
                  onOk() {},
                });
              }
            })
            .catch((e) => {
              Modal.info({
                title: '예치금 충전실패',
                content: (
                  <div>
                    예치금이 충전에 실패하였습니다. 입력한 정보를 확인해주세요.
                  </div>
                ),
                ...modalStyle,
                onOk() {},
              });
            });
        },
        onCancel() {},
      });
    }

    // const self = this;
    // this.formRef.current.resetFields();

    // Modal.info({
    //     title: "예치금 충전",
    //     content: (
    //         <div>
    //             예치금이 충전되었습니다.
    //         </div>
    //     ),
    //     onOk() {
    //         self.props.close()
    //     },
    // });
  };
  handleValuesChange = (changedValues, allValues) => {
  };

  render() {
    const { isOpen, close } = this.props;
    const cards = [
      { code: 1, name: '현대카드' },
      { code: 2, name: '삼성카드' },
      { code: 3, name: '신한카드' },
      { code: 4, name: '국민카드' },
      { code: 5, name: '우리카드' },
    ];
    const skinType = Const.skinType.toUpperCase();
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-overlay" onClick={close} />
            <div className="Modal">
              <div className="charge-content-all">
                <div
                  className="charge-content-title"
                  onClick={() => {
                    this.setState({ activeMode: 0 });
                  }}>
                  <div
                    className={this.state.activeMode === 0 && skinType === "GOGOIT"
                        ? 'gogoit-charge-content-title-text active'
                        : this.state.activeMode === 0
                            ? 'charge-content-title-text active'
                            : 'charge-content-title-text'
                    }>
                    카드결제
                  </div>
                </div>
                {!this.props.autoPay && (
                  <div
                    className="charge-content-title"
                    onClick={() => {
                      this.setState({ activeMode: 1 });
                    }}>
                    <div
                      className={this.state.activeMode === 1 && skinType === "GOGOIT"
                          ? 'gogoit-charge-content-title-text active'
                          : this.state.activeMode === 1
                              ? 'charge-content-title-text active'
                              : 'charge-content-title-text'
                      }>
                      계좌이체
                    </div>
                  </div>
                )}
                <div className="close-image" onClick={close}>
                  <img style={{ display: 'inline' }} src={CloseIcon} alt="" />
                </div>

                {/* 자동결제 변경이거나 1회 카드결제 */}
                {(this.props.autoPay || this.state.activeMode === 0) && (
                  <div>
                    <Form
                      ref={this.formRef}
                      onFinish={this.charge}
                      onValuesChange={this.handleValuesChange}>
                      <div className="charge-element-description">
                        *{' '}
                        {this.props.autoPay
                          ? '예치금이 부족한 경우 등록된 카드로 자동 결제금액 만큼 카드사 수수료(3.3%)를 제외하고 충전됩니다.'
                          : '결제금액에서 카드사 수수료(3.3%)를 제외한 금액만큼 충전됩니다.'}
                      </div>
                      <div className="charge-element-block-content">
                        {/* <div className="charge-element-block-content-field">
                                                        <div className="charge-element-block-content-field-text">카드종류 :</div>
                                                        <div className="charge-element-block-content-field-text2 mobileoff">
                                                            <FormItem
                                                                name="cardType"
                                                                rules={[{ required: true, message: '카드종류를 선택해주세요' }]}>
                                                                <Select style={{ width: '200px', fontSize: '18px', borderRadius: '7px' }} placeholder="카드선택">
                                                                    {cards.map(row => {
                                                                        return (<Option value={row.code}>{row.name}</Option>)
                                                                    })}
                                                                </Select>
                                                            </FormItem>
                                                        </div>
                                                        <div className="charge-element-block-content-field-text2 mobile">
                                                            <FormItem
                                                                name="cardType"
                                                                rules={[{ required: true, message: '카드종류를 선택해주세요' }]}>
                                                                <Select style={{ width: '170px', fontSize: '14px', borderRadius: '7px' }} placeholder="카드선택">
                                                                    {cards.map(row => {
                                                                        return (<Option value={row.code}>{row.name}</Option>)
                                                                    })}
                                                                </Select>
                                                            </FormItem>
                                                        </div>
                                                    </div> */}
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            카드번호 :
                          </div>
                          <div className="charge-element-block-content-field-text2">
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum1"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum1');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardNum2')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              -
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum2"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum2');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardNum3')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              -
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum3"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum3');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardNum4')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              -
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardNum4"
                                rules={[{ required: true, message: '미입력' }]}
                                secure="true">
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardNum4');
                                  }}
                                  autoComplete="off"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={4}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 4) {
                                      this.formRef.current
                                        .getFieldInstance('cardExpire1')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                  type="password"
                                />
                              </FormItem>
                            </div>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            유효기간 :
                          </div>
                          <div className="charge-element-block-content-field-text2">
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardExpire1"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardExpire1');
                                  }}
                                  autoComplete="off"
                                  placeholder="Month"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={2}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 2) {
                                      this.formRef.current
                                        .getFieldInstance('cardExpire2')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div className="charge-element-block-content-field-divider">
                              /
                            </div>
                            <div className="charge-element-block-content-field-card">
                              <FormItem
                                name="cardExpire2"
                                rules={[{ required: true, message: '미입력' }]}>
                                <Input
                                  onFocus={() => {
                                    this.openPhoneInputModal('cardExpire2');
                                  }}
                                  autoComplete="off"
                                  placeholder="Year"
                                  style={{ borderRadius: '7px' }}
                                  maxLength={2}
                                  onChange={(e) => {
                                    if (!e.target.value) return;
                                    if (e.target.value.length >= 2) {
                                      this.formRef.current
                                        .getFieldInstance('amount')
                                        .focus({ cursor: 'all' });
                                    }
                                  }}
                                />
                              </FormItem>
                            </div>
                            <div
                              className="mobileoff"
                              style={{
                                display: 'inline-block',
                                fontSize: '14px',
                                marginLeft: '10px',
                              }}>
                              (ex, 05/21)
                            </div>
                            <div
                              className="mobile"
                              style={{
                                display: 'inline-block',
                                fontSize: '12px',
                                marginLeft: '10px',
                              }}>
                              (ex, 05/21)
                            </div>
                          </div>
                        </div>
                        <div className="charge-element-block-content-field">
                          <div className="charge-element-block-content-field-text">
                            {this.props.autoPay ? '자동 ' : ''}결제금액 :
                          </div>
                          <div className="charge-element-block-content-field-text2 charge-input-price">
                            <FormItem
                              name="amount"
                              rules={[
                                {
                                  required: true,
                                  message: '결제할 금액을 입력해주세요',
                                },
                              ]}>
                              <Input
                                onFocus={() => {
                                  this.openPhoneInputModal('amount');
                                }}
                                autoComplete="off"
                                style={{ borderRadius: '7px' }}
                              />
                            </FormItem>
                          </div>
                        </div>
                      </div>
                      <div className="chargeKeypad">
                        <PriceInputModal
                          inline
                          diableAdd
                          isOpen={this.state.phoneInputModalOpen}
                          close={() =>
                            this.setState({ phoneInputModalOpen: false })
                          }
                          keyin={(data) => {
                            const target = this.state.phoneInputModalTarget;
                            if (!target || target === '') return;
                            const str =
                              this.formRef.current.getFieldValue(target);
                            let value = {};
                            value[target] = str ? str + data + '' : data + '';
                            this.formRef.current.setFieldsValue(value);

                            let next = '';
                            let len = 4;
                            if (target === 'cardNum1') next = 'cardNum2';
                            if (target === 'cardNum2') next = 'cardNum3';
                            if (target === 'cardNum3') next = 'cardNum4';
                            if (target === 'cardNum4') next = 'cardExpire1';
                            if (target === 'cardExpire1') {
                              next = 'cardExpire2';
                              len = 2;
                            }
                            if (target === 'cardExpire2') {
                              next = 'amount';
                              len = 2;
                            }
                            if (target === 'amount') {
                              next = '';
                              len = 1000000;
                            }

                            if (value[target].length >= len) {
                              this.formRef.current
                                .getFieldInstance(next)
                                .focus({ cursor: 'all' });
                              this.setState({ phoneInputModalTarget: next });
                            }
                          }}
                          keyadd={(data) => {
                            let str = (
                              this.formRef.current.getFieldValue(
                                'cardExpire1'
                              ) + ''
                            ).replace(/,/g, '');
                            let value = 0;
                            if (str && !isNaN(str)) value = parseInt(str);

                            this.formRef.current.setFieldsValue({
                              orderPrice: comma(value + data),
                            });
                            this.onUpdateOverPrice();
                          }}
                          backspace={() => {
                            const target = this.state.phoneInputModalTarget;
                            if (!target || target === '') return;
                            const str =
                              this.formRef.current.getFieldValue(target);
                            let value = {};
                            value[target] = str
                              ? str.substr(0, str.length - 1)
                              : '';
                            this.formRef.current.setFieldsValue(value);
                          }}
                          reset={() => {
                            const target = this.state.phoneInputModalTarget;
                            if (!target || target === '') return;
                            let value = {};
                            value[target] = '';
                            this.formRef.current.setFieldsValue(value);
                          }}
                          ok={() => {
                            this.setState({ phoneInputModalOpen: false });
                          }}
                        />
                      </div>
                      <div className="charge-btn-wrapper">
                        <Button
                          type="primary"
                          className="charge-btn"
                          htmlType="submit">
                          {this.props.autoPay ? '저장하기' : '충전하기'}
                        </Button>
                      </div>
                    </Form>
                  </div>
                )}
                {this.state.activeMode === 1 && (
                  <>
                    {this.props.loginInfo.vaccountBank ? (
                      <>
                        <div className="charge-element-description">
                          * 아래 계좌로 입금하는 경우 이체수수료 300원을
                          제외하고 충전됩니다.
                        </div>
                        <div className="charge-element-block-content">
                          <div className="charge-element-block-content-field">
                            <div className="charge-element-block-content-field-text">
                              입금은행 :
                            </div>
                            <div className="charge-element-block-content-field-text2">
                              {this.props.loginInfo.vaccountBank.split(',')[0]}
                            </div>
                          </div>
                          <div className="charge-element-block-content-field">
                            <div className="charge-element-block-content-field-text">
                              계좌번호 :
                            </div>
                            <div className="charge-element-block-content-field-text2">
                              {this.props.loginInfo.vaccountNumber}
                            </div>
                          </div>
                          <div className="charge-element-block-content-field">
                            <div className="charge-element-block-content-field-text">
                              예금주 :
                            </div>
                            <div className="charge-element-block-content-field-text2">
                              {this.props.loginInfo.vaccountDepositor}
                            </div>
                          </div>
                        </div>
                        <div className="charge-btn-wrapper">
                          <Button
                            type="primary"
                            className="charge-btn"
                            onClick={close}>
                            확인
                          </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="charge-element-description"
                          style={{ margin: '50px' }}>
                          * 충전용 가상계좌가 발급되지 않았습니다. 지점으로
                          문의해주세요
                        </div>
                      </>
                    )}
                  </>
                )}
                {/* </div>
                                <div className="guide-content">
                                    <div>
                                        <div className="bullet-dots" />
                                        <div className="guide-content-text">
                                            배송가이드
                                    </div>
                                    </div>
                                    <div>
                                        <div className="dots" />
                                        <div className="guide-content-text2">
                                            고객부재/ 연락두절 : MCC로 연락, 처리방법 확인
                                    </div>
                                    </div>
                                    <div>
                                        <div className="dots" />
                                        <div className="guide-content-text3">
                                            재이동 : 이동 전 MCC로 연락, 상점 승인 후 진행
                                    </div>
                                    </div>
                                    <div>
                                        <div className="dots" />
                                        <div className="guide-content-text4">
                                            반납 : 0.5 건 추가
                                    </div>
                                    </div>
                                    <div>
                                        <div className="dots" />
                                        <div className="guide-content-text5">
                                            배상 : 상품가액의 50%
                                    </div>
                                    </div>
                                    <div>
                                        <div className="guide-content-text6">
                                            ※ 고객 과실은 배송신청 주체인 상점주의 과실로 간주됩니다.
                                    </div>
                                    </div> */}
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default ChargeModal;
